import { FC } from 'react';
import Button from 'shared/components/Button';
import ViajeLLTPaisEdit from '../ViajeLLTPaisEdit';
import { TransferReservationManagementListModel } from '../../models/TransferReservationManagementList';
import { tw } from 'utils/tailwindUtils';
import { useSnackbar } from 'notistack';

interface ActionsItemGestionProps {
  currentTravel: TransferReservationManagementListModel;
  onBusesPreAssign: (travel: TransferReservationManagementListModel) => void;
  onReservationCopy: (travel: TransferReservationManagementListModel) => void;
  onReservationShowDetails: (id: number) => React.ReactNode;
  onOpenEditLLtPais: (
    reservation: TransferReservationManagementListModel
  ) => void;
  copyReservationPublicNewLinkToClipboard: (id: number) => Promise<void>;
}

const ActionsItemGestion: FC<ActionsItemGestionProps> = ({
  currentTravel,
  onBusesPreAssign,
  onReservationCopy,
  onReservationShowDetails,
  onOpenEditLLtPais,
  copyReservationPublicNewLinkToClipboard
}) => {
  const snackbar = useSnackbar();

  return (
    <div className="flex flex-col gap-2">
      <div className="flex space-x-2">
        <Button
          variant="dashed"
          onClick={() => onReservationCopy(currentTravel)}
        >
          Copiar
        </Button>
        {onReservationShowDetails(currentTravel.id)}
      </div>
      <Button
        className={tw({
          hidden: currentTravel.lltpais // Si es LLT-pais no mostrar el botón para link de seguimiento.
        })}
        variant="dashed"
        onClick={async () => {
          await copyReservationPublicNewLinkToClipboard(currentTravel.id);
          snackbar.enqueueSnackbar('Link de seguimiento copiado', {
            variant: 'info'
          });
        }}
      >
        Copiar link
      </Button>
      <ViajeLLTPaisEdit
        currentTravel={currentTravel}
        onOpenEditLLtPais={onOpenEditLLtPais}
      />
      {currentTravel?.bus_requirement && (
        <Button
          onClick={() => onBusesPreAssign(currentTravel)}
          variant="dashed"
          className="mb-2 w-full"
        >
          Editar SG
        </Button>
      )}
    </div>
  );
};

export default ActionsItemGestion;
